export default "/p/@slug";
